/**
 * Presents the given information in a simple alert
 */
export default function showAlert (title: string, message?: string): void {
  window.alert(`${title}${message == null ? '' : `\n\n${message}`}`)
}
